
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/weather",
      function () {
        return require("private-next-pages/[region]/[resort]/weather.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/weather"])
      });
    }
  